import { render, staticRenderFns } from "./ViewMessage.page.vue?vue&type=template&id=d1ce32dc&"
import script from "./ViewMessage.page.vue?vue&type=script&lang=js&"
export * from "./ViewMessage.page.vue?vue&type=script&lang=js&"
import style0 from "./ViewMessage.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports